import { Container } from '@components/ui'
import ColorIdentifier from '@components/ui/ColorIdentifier'
import config from '@config/seo_meta.json'
import Image from 'next/legacy/image'
import { useState } from 'react'
interface Props {
  slice: any
}
const ImageSplit = ({ slice }: Props) => {
  const { primary } = slice
  const imageLayout = primary?.imageLayout
  const splitLayout43 = primary?.imageLayout === '4:3'
  const splitLayout34 = primary?.imageLayout === '3:4'
  const halfLayout = primary?.imageLayout === '5:5'
  const leftImage = primary?.leftImage
  const leftImageCredit = primary?.leftImageCredit
  const leftImageColour = primary?.leftImageColour
  const leftImageColourName = primary?.leftImageColourName
  const rightImage = primary?.rightImage
  const rightImageCredit = primary?.rightImageCredit
  const rightImageColour = primary?.rightImageColour
  const rightImageColourName = primary?.rightImageColourName
  const leftImageWidth = () => {
    switch (imageLayout) {
      case '5:5':
        return '640'
      case '4:3':
        return '819'
      case '3:4':
        return '461'
    }
  }
  const imageHeight = () => {
    switch (imageLayout) {
      case '5:5':
        return '854'
      case '4:3':
        return '614'
      case '3:4':
        return '614'
    }
  }
  const rightImageWidth = () => {
    switch (imageLayout) {
      case '5:5':
        return '640'
      case '4:3':
        return '461'
      case '3:4':
        return '819'
    }
  }
  const [isLeftHover, setIsLeftHover] = useState(false)
  const [isRightHover, setIsRightHover] = useState(false)
  const handleLeftHover = () => {
    setIsLeftHover(true)
  }
  const handleLeftLeave = () => {
    setIsLeftHover(false)
  }
  const handleRightHover = () => {
    setIsRightHover(true)
  }
  const handleRightLeave = () => {
    setIsRightHover(false)
  }
  const leftImageContent = {
    colorName: leftImageColourName,
    colorHexCode: leftImageColour,
  }
  const rightImageContent = {
    colorName: rightImageColourName,
    colorHexCode: rightImageColour,
  }
  return (
    <Container
      clean={!primary?.insideContainer}
      className="wrapper bg-ui-light-grey pb-6 lg:pb-10"
    >
      <div className="flex flex-col gap-6 lg:w-full lg:flex-row lg:gap-8">
        {leftImage && (
          <div className="leftImage flex h-full flex-col gap-3">
            <div
              onMouseOver={() => handleLeftHover()}
              onMouseLeave={() => handleLeftLeave()}
              className="relative"
            >
              <Image
                src={leftImage?.url || '/product-img-placeholder.svg'}
                alt={leftImage?.alt || config.openGraph.images[0].alt}
                width={leftImageWidth()}
                height={imageHeight()}
                layout="responsive"
                objectFit="cover"
              />
              <div className="hidden lg:block">
                {isLeftHover && (
                  <div className="absolute top-0 left-0 h-full w-full bg-brand-dark-grey opacity-20"></div>
                )}
                {isLeftHover && leftImageColour && leftImageColourName && (
                  <div className="absolute bottom-7 left-6">
                    <ColorIdentifier color={leftImageContent} />
                  </div>
                )}
              </div>
              <div className="block lg:hidden">
                {leftImageColour && leftImageColourName && (
                  <div className="absolute bottom-5 left-4">
                    <ColorIdentifier color={leftImageContent} />
                  </div>
                )}
              </div>
            </div>
            {leftImageCredit && (
              <div className="body-2 text-brand-dark-grey">
                {leftImageCredit}
              </div>
            )}
          </div>
        )}
        {rightImage && (
          <div className="rightImage flex h-full flex-col gap-3">
            <div
              onMouseOver={() => handleRightHover()}
              onMouseLeave={() => handleRightLeave()}
              className="relative"
            >
              <Image
                src={rightImage?.url || '/product-img-placeholder.svg'}
                alt={rightImage?.alt || config.openGraph.images[0].alt}
                width={rightImageWidth()}
                height={imageHeight()}
                layout="responsive"
                objectFit="cover"
              />
              <div className="hidden lg:block">
                {isRightHover && (
                  <div className="absolute top-0 left-0 h-full w-full bg-brand-dark-grey opacity-20"></div>
                )}
                {isRightHover && rightImageColour && rightImageColourName && (
                  <div className="absolute bottom-7 left-6">
                    <ColorIdentifier color={rightImageContent} />
                  </div>
                )}
              </div>
              <div className="block lg:hidden">
                {rightImageColour && rightImageColourName && (
                  <div className="absolute bottom-5 left-4">
                    <ColorIdentifier color={rightImageContent} />
                  </div>
                )}
              </div>
            </div>
            {rightImageCredit && (
              <div className="body-2 text-brand-dark-grey">
                {rightImageCredit}
              </div>
            )}
          </div>
        )}
      </div>
      <style jsx>{`
        .leftImage {
          flex: ${halfLayout && '1'};
          flex: ${splitLayout43 && '1.33387622'};
          flex: ${splitLayout34 && '0.75081433'};
        }
        .rightImage {
          flex: ${halfLayout && '1'};
          flex: ${splitLayout43 && '0.75081433'};
          flex: ${splitLayout34 && '1.33387622'};
        }
      `}</style>
    </Container>
  )
}

export default ImageSplit
